import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["overlayPlaceholder", "autoFocusSearch", "menuPosition", "components", "shouldHideOverlayIfNotVisible", "additionalOverrideProps", "styles", "overlayContainerClassName"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable import/order */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { defaultMemoize } from 'reselect';
import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _propery from 'lodash/property';
import _compact from 'lodash/compact';
import _map from 'lodash/map';
import _omit from 'lodash/omit';
import _noop from 'lodash/noop';
import { getSanitizedOptions } from '@tekion/tekion-base/utils/selectSort';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { DEFAULT_SELECT_SORT_ORDER } from '@tekion/tekion-base/constants/sortOrder';
import COLORS from 'tstyles/variables.scss'; // eslint-disable-line

import SelectedValues from './selectedValues';
import DropDown from '../../DropDown';
import SearchIcon from './SearchIcon';
import Option from '../../advancedSelect/components/option';
import { getSelectStyles } from '../../advancedSelect/styles/AdvancedSelect.styles';
import { getSelectValues } from '../../advancedSelect/containers/withBaseSelect/withBaseSelect.helpers';
import s from './withMultiSelect.module.scss';
var UNWANTED_SELECT_PROPS = ['hasError'];
var MULTISELECT_DROPDOWN_TRIGGER = ['click'];
var SELECT_ACTIONS = {
  INPUT_CHANGE: 'input-change',
  MENU_CLOSE: 'menu-close',
  SET_VALUE: 'set-value',
  INPUT_BLUR: 'input-blur'
};
var COMPONENTS = {
  DropdownIndicator: SearchIcon,
  IndicatorSeparator: null,
  Option: Option
};
var getMenuStyles = function getMenuStyles() {
  return {
    marginTop: 0
  };
};
var getDropdownIndicator = function getDropdownIndicator() {
  return {
    marginRight: '1.2rem'
  };
};
var getOptionStyles = function getOptionStyles(styles, props) {
  var isMulti = props.isMulti,
    data = props.data;
  if (isMulti) {
    return _objectSpread(_objectSpread({}, (data === null || data === void 0 ? void 0 : data.styles) || EMPTY_OBJECT), {}, {
      backgroundColor: COLORS.white,
      color: 'inherit'
    });
  }
  return undefined;
};
var getControlStyles = function getControlStyles(styles, props) {
  var isFocused = props.isFocused;
  var baseStyles = {
    ':hover': {
      borderColor: '#d4d5d6'
    }
  };
  if (isFocused) {
    baseStyles.borderColor = '#d4d5d6';
  }
  return baseStyles;
};
var getMultiSelectValuesSelector = function getMultiSelectValuesSelector() {
  return defaultMemoize(function (values, options) {
    var displayKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';
    return _compact(_map(getSelectValues(_propery('value'), options, values), displayKey));
  });
};
var getMultiSelectValuesForNewSelect = function getMultiSelectValuesForNewSelect(value) {
  return _map(value, 'label');
};
var STYLE_OVERRIDES = {
  menu: getMenuStyles,
  dropdownIndicator: getDropdownIndicator,
  option: getOptionStyles,
  control: getControlStyles
};
var getValueLabelsToBeShown = function getValueLabelsToBeShown(options) {
  return _filter(options, function (option) {
    return _get(option, 'showInSelectedValues', true);
  });
};
var withMultiSelect = function withMultiSelect(SelectComponent) {
  var WithMultiSelect = /*#__PURE__*/function (_PureComponent) {
    _inherits(WithMultiSelect, _PureComponent);
    var _super = _createSuper(WithMultiSelect);
    function WithMultiSelect(props) {
      var _this;
      _classCallCheck(this, WithMultiSelect);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "getSelectStyles", defaultMemoize(getSelectStyles));
      _defineProperty(_assertThisInitialized(_this), "setRef", function (ref) {
        _this.selectedValuesRef = ref;
      });
      _defineProperty(_assertThisInitialized(_this), "handleVisibilityChange", function (isVisible) {
        _this.setState({
          isVisible: isVisible
        });
      });
      _defineProperty(_assertThisInitialized(_this), "getValue", function () {
        var _this$props = _this.props,
          value = _this$props.value,
          values = _this$props.values,
          newSelect = _this$props.newSelect;
        return newSelect ? value : values;
      });
      // NOTE: default behaviour of Select will clear the search text on option select, hence added this custom handler in order to retain search text
      _defineProperty(_assertThisInitialized(_this), "onInputChange", function (inputValue) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT,
          action = _ref.action;
        switch (action) {
          case SELECT_ACTIONS.INPUT_CHANGE:
            {
              _this.searchText = inputValue;
              return inputValue;
            }
          case SELECT_ACTIONS.MENU_CLOSE:
            {
              _this.searchText = EMPTY_STRING;
              return EMPTY_STRING;
            }
          case SELECT_ACTIONS.SET_VALUE:
          case SELECT_ACTIONS.INPUT_BLUR:
            // NOTE: getting inputValue as empty for these actions, hence need to maintain searchText in state
            return _this.searchText;
          default:
            return inputValue;
        }
      });
      _this.getSanitizedOptions = defaultMemoize(getSanitizedOptions);
      _this.getMultiSelectValues = props.newSelect ? getMultiSelectValuesForNewSelect : getMultiSelectValuesSelector();
      _this.getValueLabelsToBeShown = defaultMemoize(getValueLabelsToBeShown);
      _this.state = {
        isVisible: false
      };
      _this.searchText = EMPTY_STRING;
      return _this;
    }
    _createClass(WithMultiSelect, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var initialize = this.props.initialize;
        initialize();
      }
    }, {
      key: "renderOverlay",
      value: function renderOverlay(options) {
        var isVisible = this.state.isVisible;
        var _this$props2 = this.props,
          overlayPlaceholder = _this$props2.overlayPlaceholder,
          autoFocusSearch = _this$props2.autoFocusSearch,
          menuPosition = _this$props2.menuPosition,
          components = _this$props2.components,
          shouldHideOverlayIfNotVisible = _this$props2.shouldHideOverlayIfNotVisible,
          additionalOverrideProps = _this$props2.additionalOverrideProps,
          styles = _this$props2.styles,
          overlayContainerClassName = _this$props2.overlayContainerClassName,
          rest = _objectWithoutProperties(_this$props2, _excluded);
        if (!isVisible && shouldHideOverlayIfNotVisible) return /*#__PURE__*/React.createElement("div", null);
        var _ref2 = additionalOverrideProps || EMPTY_OBJECT,
          _ref2$overrideWithBas = _ref2.overrideWithBaseSelectStyles,
          overrideWithBaseSelectStyles = _ref2$overrideWithBas === void 0 ? false : _ref2$overrideWithBas;
        var selectStylesOverride = overrideWithBaseSelectStyles ? this.getSelectStyles(_objectSpread(_objectSpread({}, styles), STYLE_OVERRIDES)) : STYLE_OVERRIDES;
        return /*#__PURE__*/React.createElement(SelectComponent, _extends({}, _omit(rest, UNWANTED_SELECT_PROPS), {
          options: options,
          autoFocus: autoFocusSearch,
          backspaceRemovesValue: false,
          controlShouldRenderValue: false,
          hideSelectedOptions: false,
          isClearable: false,
          menuIsOpen: isVisible,
          closeMenuOnSelect: false,
          onInputChange: this.onInputChange,
          key: isVisible,
          value: this.getValue(),
          placeholder: overlayPlaceholder,
          menuPosition: menuPosition,
          menuPortalTarget: this.selectedValuesRef,
          components: _objectSpread(_objectSpread({}, COMPONENTS), components),
          className: "".concat(s.overlay, " ").concat(overlayContainerClassName),
          styles: selectStylesOverride,
          styleOverrides: selectStylesOverride,
          isMulti: true
        }));
      }
    }, {
      key: "render",
      value: function render() {
        var _cx, _cx2;
        var isVisible = this.state.isVisible;
        var _this$props3 = this.props,
          className = _this$props3.className,
          options = _this$props3.options,
          error = _this$props3.error,
          dropDownClassName = _this$props3.dropDownClassName,
          id = _this$props3.id,
          selectedValuesPlaceholder = _this$props3.selectedValuesPlaceholder,
          displayKey = _this$props3.displayKey,
          disabled = _this$props3.disabled,
          sort = _this$props3.sort,
          shouldSortOptions = _this$props3.shouldSortOptions,
          selectedValuesContent = _this$props3.selectedValuesContent;
        var updatedOptions = this.getSanitizedOptions(options, shouldSortOptions, sort);
        var valueLabelsToBeShown = this.getValueLabelsToBeShown(updatedOptions);
        var value = this.getValue();
        return /*#__PURE__*/React.createElement(DropDown, {
          disabled: disabled,
          visible: isVisible,
          onVisibleChange: this.handleVisibilityChange,
          trigger: MULTISELECT_DROPDOWN_TRIGGER,
          overlay: this.renderOverlay(updatedOptions),
          className: cx((_cx = {}, _defineProperty(_cx, dropDownClassName, dropDownClassName), _defineProperty(_cx, s.multiSelectDropdown, dropDownClassName), _defineProperty(_cx, s.errorStyle, !!error), _cx))
        }, /*#__PURE__*/React.createElement("div", {
          ref: this.setRef
        }, _isEmpty(selectedValuesContent) && /*#__PURE__*/React.createElement(SelectedValues, {
          isVisible: isVisible,
          className: cx((_cx2 = {}, _defineProperty(_cx2, className, true), _defineProperty(_cx2, s.multiDisabled, !!disabled), _cx2)),
          placeHolder: selectedValuesPlaceholder,
          valueLabels: this.getMultiSelectValues(value, valueLabelsToBeShown, displayKey),
          id: id
        }), !_isEmpty(selectedValuesContent) && selectedValuesContent));
      }
    }]);
    return WithMultiSelect;
  }(PureComponent);
  WithMultiSelect.propTypes = {
    overlayPlaceholder: PropTypes.string,
    autoFocusSearch: PropTypes.bool,
    menuPosition: PropTypes.string,
    disabled: PropTypes.bool,
    shouldHideOverlayIfNotVisible: PropTypes.bool,
    initialize: PropTypes.func,
    sort: PropTypes.arrayOf(PropTypes.shape({
      order: PropTypes.string,
      field: PropTypes.string
    })),
    shouldSortOptions: PropTypes.bool,
    components: PropTypes.object,
    overlayContainerClassName: PropTypes.string
  };
  WithMultiSelect.defaultProps = {
    overlayPlaceholder: __('Search'),
    autoFocusSearch: true,
    shouldHideOverlayIfNotVisible: false,
    menuPosition: 'fixed',
    disabled: false,
    initialize: _noop,
    sort: DEFAULT_SELECT_SORT_ORDER,
    shouldSortOptions: false,
    components: EMPTY_OBJECT,
    overlayContainerClassName: EMPTY_STRING
  };
  return WithMultiSelect;
};
export default withMultiSelect;